import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import type { AppState } from "./appStatesReducer.d";

// Define the initial state using that type
const initialState: AppState = {
  value: "",
  permission: "",
  user_permission: [],
  original_user_permission: [], // Add this to store original permissions
  role: {
    id: "",
    name: "",
    role: "",
    permission: [],
  },
  permissions: [],
  marketPlaceCurrency: "USD",
  profile: "",
};

export const appStateSlice = createSlice({
  name: "appState",
  // `createSlice` will infer the state type from the `initialState` argument
  // Use the PayloadAction type to declare the contents of `action.payload`
  initialState,
  //CRUD
  reducers: {
    setAppState: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },

    setAppPermission: (
      state,
      action: PayloadAction<AppState["permission"]>
    ) => {
      state.permission = action.payload;
    },
    setAppPermissions: (
      state,
      action: PayloadAction<AppState["permissions"]>
    ) => {
      state.permissions = [...action.payload];
    },
    setUserPermission: (
      state,
      action: PayloadAction<AppState["user_permission"]>
    ) => {
      state.user_permission = [...action.payload];
    },
    setOriginalUserPermission: (
      state,
      action: PayloadAction<AppState["user_permission"]>
    ) => {
      state.original_user_permission = [...action.payload];
    },
    setRole: (state, action: PayloadAction<AppState["role"]>) => {
      state.role = action.payload;
    },
    setProfile: (state, action: PayloadAction<AppState["profile"]>) => {
      state.profile = action.payload;
    },
    setMarketPlaceCurrency: (
      state,
      action: PayloadAction<AppState["marketPlaceCurrency"]>
    ) => {
      state.marketPlaceCurrency = action.payload;
    },
    clearAppState: () => initialState,
  },
});

export const {
  setAppState,
  setAppPermission,
  setAppPermissions,
  setUserPermission,
  setOriginalUserPermission,
  setRole,
  setProfile,
  setMarketPlaceCurrency,
  clearAppState,
} = appStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectappState = (state: RootState) => state.appState.value;
export const selectappPermission = (state: RootState) =>
  state.appState.permission;

export default appStateSlice.reducer;
